import { Box } from '@xstyled/styled-components';
import SortSelect from './SortSelect';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { FilterBoxArrows } from '@/UI/Icons/Catalogue';
import { useTranslation } from 'next-i18next';

export default function Sort() {
  const { t } = useTranslation();

  return (
    <FlexBox
      align="center"
      justify={{ _: 'flex-start', mobile: 'center' }}
      spaceX={{ _: '0', desktop: '1rem' }}
    >
      <Box display={{ desktop: 'none' }}>
        <span role="img" aria-label="Filter products">
          {FilterBoxArrows}
        </span>
      </Box>
      <span> &nbsp; {t('filter.sort')}:</span>
      <SortSelect />
    </FlexBox>
  );
}

